import React, { Component, Fragment } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import authService from '../../services/AuthService';

import './CadeReport.css';

class CadeReportDomain extends Component {
    constructor(props) {
        super(props);

        this.state = {
            assessmentId: props.assessmentId,
            cadeDomain: props.cadeDomain,
            domainName: props.domainName,
            domainImpressions: props.domainImpressions,
            includeDomain: props.includeDomain,
            includeDomainDescription: props.includeDomainDescription,
            includeDomainRadarChart: props.includeDomainRadarChart,
            includeDomainTypical: props.includeDomainTypical,
            includeDomainConcerns: props.includeDomainConcerns,
            includeDomainRecommendations: props.includeDomainRecommendations
        }
    }

    domainImpressionsChangeHandler = (event) => {
        // Not wanting a react state change so setting directly.
        this.state.domainImpressions = event.target.value;
        this.saveHandler();
    }

    incDomainChangeHandler = (event) => {
        this.state.includeDomain = event.target.checked;
        this.props.navUpdateReportHandler((this.state.includeDomain) ? null : "/content/DocDelete64.png");
        this.saveHandler();
    }

    incDomainDescChangeHandler = (event) => {
        this.state.includeDomainDescription = event.target.checked;
        this.saveHandler();
    }

    incDomainRadarChangeHandler = (event) => {
        this.state.includeDomainRadarChart = event.target.checked;
        this.saveHandler();
    }

    incDomainTypicalChangeHandler = (event) => {
        this.state.includeDomainTypical = event.target.checked;
        this.saveHandler();
    }

    incDomainConcernsChangeHandler = (event) => {
        this.state.includeDomainConcerns = event.target.checked;
        this.saveHandler();
    }

    incDomainRecsChangeHandler = (event) => {
        this.state.includeDomainRecommendations = event.target.checked;
        this.saveHandler();
    }

    saveHandler = () => {
        this.props.saveHandler(this.state.assessmentId, this.state.cadeDomain, this.state.domainImpressions, this.state.includeDomain, this.state.includeDomainDescription,
            this.state.includeDomainRadarChart, this.state.includeDomainTypical, this.state.includeDomainConcerns, this.state.includeDomainRecommendations);
    }

    gotoAssessmentHandler = () => {
        if (authService.isClearClinician) {
            this.props.domainChangeHandler("CadeAssessment");
        }
        else {
            this.props.domainChangeHandler("CadePartnerAssessment");
        }
    }

    render() {
        let isPartnerProvider = authService.isPartnerProvider;
        return (
            
            <Fragment>
                {isPartnerProvider &&
                    <Button variant="primary" size="sm" className="tour_reportSelection" onClick={this.gotoAssessmentHandler}>Select Report Type and Generate Report</Button>
                }
                {!isPartnerProvider &&

                    <Form>
                    <Button variant="primary" size="sm" className="tour_reportSelection" onClick={this.gotoAssessmentHandler}>Select Report Type and Generate Report</Button>
                    <h4 className="cadeReport_sectionHeading">Clinician's Impressions for the {this.state.domainName} Domain</h4>
                    <p className="cadeReport_explanation">(only used in the diagnostic report)</p>
                        <Form.Group controlId="reportDomainImpressions">
                        <Form.Control id="domainImpressions" className="tour_reportDiagnosticInput" as="textarea" rows="8" defaultValue={this.state.domainImpressions} onBlur={this.domainImpressionsChangeHandler} disabled={this.props.readonly} />
                    </Form.Group>
                    {false && 
                        <Fragment>
                        <h4 className="cadeReport_sectionHeading">Include {this.state.domainName} Domain in the Report</h4>
                        <Form.Check id="includeDomain" type="checkbox" label="Include Domain in report" checked={this.state.includeDomain} onChange={this.incDomainChangeHandler} disabled={this.props.readonly} />
  
                        {this.state.includeDomain &&
                            <Fragment>
                                <h4 className="cadeReport_sectionHeading">{this.state.domainName} Domain Report Sections</h4>
                                <Form.Group controlId="reportDomainIncDomain">
                                    <Form.Check id="includeDomainDescription" bsPrefix="form-check cadeReport_cfgItem" type="checkbox" label="Include Domain Description" checked={this.state.includeDomainDescription} onChange={this.incDomainDescChangeHandler} disabled={this.props.readonly} />
                                    <Form.Check id="includeDomainRadarChart" bsPrefix="form-check cadeReport_cfgItem" type="checkbox" label="Include Domain Radar Chart" checked={this.state.includeDomainRadarChart} onChange={this.incDomainRadarChangeHandler} disabled={this.props.readonly} />
                                    <Form.Check id="includeDomainTypical" bsPrefix="form-check cadeReport_cfgItem" type="checkbox" label="Include Domain Typical Development" checked={this.state.includeDomainTypical} onChange={this.incDomainTypicalChangeHandler} disabled={this.props.readonly} />
                                    <Form.Check id="includeDomainConcerns" bsPrefix="form-check cadeReport_cfgItem" type="checkbox" label="Include Domain Areas of Concern" checked={this.state.includeDomainConcerns} onChange={this.incDomainConcernsChangeHandler} disabled={this.props.readonly} />
                                    <Form.Check id="includeDomainRecommendations" bsPrefix="form-check cadeReport_cfgItem" type="checkbox" label="Include Domain Recommendations" checked={this.state.includeDomainRecommendations} onChange={this.incDomainRecsChangeHandler} disabled={this.props.readonly} />
                                </Form.Group>
                            </Fragment>
                        }
                        
                        </Fragment>
                    }
                    
                    </Form>
                }
            </Fragment>
        )
    }
}

export default CadeReportDomain;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeReportDomain.js